// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3s9g9","rootMobile":"styles_rootMobile__14Stc"};